import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class GeneralAuthority extends HrCommonAuthority {

    public static readonly GENERAL_BASE = "general";

    constructor(authority: string) {
        super(combineAuth(GeneralAuthority.GENERAL_BASE, authority));
    }


}
